export const GET_AGREEMENT_START='GET_AGREEMENT_START';
export const GET_AGREEMENT_SUCCESS='GET_AGREEMENT_SUCCESS';
export const GET_AGREEMENT_FAIL='GET_AGREEMENT_FAIL';

export const SHOW_AGREEMENT='SHOW_AGREEMENT';
export const HIDE_AGREEMENT='HIDE_AGREEMENT';